/**
 * sl-728o.3.1: Process Advanced (Workflow) Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createProcessAdvancedSession(t: I18n): TutorialSession {
  return {
    id: 'automation:processWorkflow',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'process',
    },
    steps: [
      {
        targetSelector: '[data-coachmark-target="retry-toggle"]',
        title: t['com.streamlain.streamlain.coach.retry.title'](),
        content: t['com.streamlain.streamlain.coach.retry.content'](),
        animation: 'pulse',
      },
      {
        targetSelector: '[data-coachmark-target="on-failure-menu"]',
        title: t['com.streamlain.streamlain.coach.failure.title'](),
        content: t['com.streamlain.streamlain.coach.failure.content'](),
        animation: 'highlight',
      },
    ],
  };
}
